import { t } from "@/i18n-js/instance";
import { AVAILABLE_WORKFLOW_ACTION_AS_PER_PLAN_TIERS } from "@circle-react/components/SettingsApp/Workflows/constants";
import { Icon } from "@circle-react-shared/Icon";
import type { ActionOption } from "../types";
import { FormTag } from "./shared/FormTag";
import { HistoryDetailViewTag } from "./shared/HistoryDetailViewTag";
import type { HistoryDetailViewTagProps } from "./shared/HistoryDetailViewTag/HistoryDetailViewTag";
import { ViewTag } from "./shared/ViewTag";

export const addTag: Readonly<ActionOption<HistoryDetailViewTagProps>> = {
  label: t("settings.workflows.form.actions.add_tag"),
  value: "add_tag_to_community_member",
  group: t("settings.workflows.form.action_groups.tags"),
  leftAddon: <Icon type="16-tag" size={16} className="!h-4 !w-4" />,
  formComponent: FormTag,
  viewComponent: ViewTag,
  historyDetailViewComponent: HistoryDetailViewTag,
  icon: "tag",
  isApplicableToMembersOnly: false,
  availablePlanTier:
    AVAILABLE_WORKFLOW_ACTION_AS_PER_PLAN_TIERS.MH_WITH_LOWER_OR_HIGHER_TIER_PLAN,
} as const;
